import Link from "next/link";
import styles from "../../styles/races/ResultsNavBar.module.scss";

const ResultsNavBar = ({ url, path = "senator", view = "results" }) => {
  const handleActiveLink = (currentView) => {
    return view === currentView
      ? `${styles.items} ${styles.active}`
      : styles.items;
  };

  const CustomLinkWrapper = ({ selectedView, children }) => {
    return (
      <Link href={url + path + "/" + selectedView} passHref>
        <a className={handleActiveLink(selectedView)}>{children}</a>
      </Link>
    );
  };

  return (
    <nav className={styles.resultsNavContainer}>
      <CustomLinkWrapper selectedView="results">
        PARTIAL RESULTS
      </CustomLinkWrapper>
      <CustomLinkWrapper selectedView="official-results">
          OFFICIAL RESULTS
      </CustomLinkWrapper>
      <CustomLinkWrapper selectedView="overseas-absentee-voting-results">
        OAV RESULTS
      </CustomLinkWrapper>
      {path === "president-vice-president" && (
        <CustomLinkWrapper selectedView="map-results">MAP</CustomLinkWrapper>
      )}
    </nav>
  );
};

export default ResultsNavBar;
